import React from 'react';
import { Link } from 'react-router-dom';

const Footer = props => {
    return (
        <footer className="footer p-0">
        <div className="footer-top">                
            <div className="container-fluid">
                <div className="row">
                    <div className="column col-md-4 p-4">
                        <div className="footer-contents">
                            <a href="#"><h1 className="display-4 footer-brand tfx-1">Easy Crypto Coins</h1></a>
                            <p className="text-muted">
                                <strong>Easy Crypto Coins</strong> is dedicated to give Crypto Coin lovers an easy way to earn
                                their favorite Crypto Coins in one single place.
                            </p>

                            <ul className="social-container">
                                <li className="socials">
                                    <a href="https://www.facebook.com/groups/414461713003854/" target="_blank" rel="noreferrer" className="social-link">
                                        <span className="social-icon text-muted"><i className="fa fa-facebook tfx-1"></i></span>
                                    </a>
                                </li>
                                <li className="socials">
                                    <a href="https://twitter.com/EasyCryptoCoin1" target="_blank" rel="noreferrer" className="social-link">
                                        <span className="social-icon text-muted"><i className="fa fa-twitter tfx-1"></i></span>
                                    </a>
                                </li>
                                <li className="socials">
                                    <a href="#" target="_blank" rel="noreferrer" className="social-link">
                                        <span className="social-icon text-muted"><i className="fa fa-instagram tfx-1"></i></span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="column col-md-4 p-4">
                        <div className="footer-contents">
                        <h1 className="display-4 footer-brand">Useful Links</h1>
                            <ul className="useful-links">
                                <li className="links">
                                    <Link to="/" className="text-muted tfx-1">Home</Link>
                                </li>
                                <li className="links">
                                    <Link to="/ptc-sites" className="text-muted tfx-1">Get Started</Link>
                                </li>
                                <li className="links">
                                    <Link to="/about" className="text-muted tfx-1">About</Link>
                                </li>
                                <li className="links">
                                    <Link to="/credits" className="text-muted tfx-1">Credits</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="column col-md-4 p-4">
                        <div className="footer-contents">
                            <h1 className="display-4 footer-brand">Just A Small Gift</h1>
                            <p className="text-muted footer-donate">
                                BCH:<br/> <span className="tfx-1">qpl7xhwmyrluhaee4ht0480804rvp567u5cszld8hh</span> <br/><br/>
                                ZEC Address:<br/> <span className="tfx-1">t1e9LvSEu9UzQwjPMCeGx5w5aM9Sp2bTy45</span> <br/><br/>
                                LTC Address:<br/> <span className="tfx-1">LRHx2sAqpai3ZhQ8KbMnTefSUFCdCskPAe</span> <br/><br/>
                                Payeer:<br/> <span className="tfx-1">P1032537379</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="footer-bottom">              
            <div className="container-fluid">
                <div className="row">
                    <div className="column col-md-6">           
                        <small><span className="text-muted">Copyright &copy; 2020-<script>document.write(new Date().getFullYear())</script> Easy Crypto Coins. All Rights Reserved.</span></small>
                    </div>
                    
                    <div className="column col-md-6">   
                        <small><span className="text-muted">Created By &hearts;	Zaids</span></small>
                    </div>
                </div>
            </div>
        </div>
</footer>
    )
}

export default Footer;
